import { baseBackend } from "../../../../api/base/baseUrl";

const RATES_GLOBAL_CITY_URL = "/api/v2/rates/global_city";

export async function createGlobalCityRequest(payload) {
  const response = await baseBackend.post(RATES_GLOBAL_CITY_URL, payload);
  return response.data;
}

export async function getGlobalCityListRequest() {
  const response = await baseBackend.get(RATES_GLOBAL_CITY_URL);
  return response.data;
}
